import {
  DELETE_TRACKER_RECORD,
  DELETE_TRACKER_RECORD_SUCCESS,
  DELETE_TRACKER_RECORD_ERROR,
  DELETE_TRACKER_RECORD_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DeleteTrackerRecord = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_TRACKER_RECORD:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DELETE_TRACKER_RECORD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case DELETE_TRACKER_RECORD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DELETE_TRACKER_RECORD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DeleteTrackerRecord;
